// extracted by mini-css-extract-plugin
export default {"inputField":"style_inputField__rNnjv","ageGen":"style_ageGen__hcCul"};